import { SET_INPUT_OFFER_CONTACT_US, SET_DID_SUBMIT_OFFER_CONTACT_US, 
    SET_ERROR_MESSAGE_OFFER_CONTACT_US, SET_LOADING_OFFER_CONTACT_US } from '../actions/OfferContactUsActions'

const initialState = {
    submit: {
        isSubmitting: false,
        didSubmit: false,
        error: false,
        errorMessage: "",
    },
    name: "",
    phone: "",
    email: "",
}

const OfferContactUsReducer = (state = initialState, action) => {
    switch(action.type) {
        case SET_INPUT_OFFER_CONTACT_US:
            return {
                ...state,
                [action.id]: action.value,
            }
        case SET_DID_SUBMIT_OFFER_CONTACT_US:
            return {
                ...state,
                submit: {
                    ...state.submit,
                    isSubmitting: false,
                    didSubmit: true,
                    error: false,
                    errorMessage: "",
                }
            }
        case SET_ERROR_MESSAGE_OFFER_CONTACT_US:
            return {
                ...state,
                submit: {
                    ...state.submit,
                    isSubmitting: false,
                    didSubmit: false,
                    error: true,
                    errorMessage: action.message,
                }
            }
        case SET_LOADING_OFFER_CONTACT_US:
            return {
                ...state,
                submit: {
                    ...state.submit,
                    isSubmitting: action.newValue,
                }
            }
        default:
            return state;
    }
}

export default OfferContactUsReducer;